import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import applicationComander from "../../../store/commanders/application.comander";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { faLongArrowAltLeft } from "@fortawesome/free-solid-svg-icons";

import {
  Box,
  Button,
  Group,
  List,
  Space,
  Text,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { Icon } from "@fortawesome/fontawesome-svg-core";
import { Redirect } from "react-router-dom";

const ChangePasswordPage = (props) => {
  const history = useHistory();
  const appState = useSelector((state: any) => state.application);

  const tempSession = useSelector(
    (state: any) => state.application.tempSession
  );

  const onSubmit = (data) =>
    applicationComander.cmd_new_password(data.new_password, tempSession);

  const form = useForm({
    initialValues: {
      new_password: "",
    },
  });

  if (!appState.authorise) {
    return (
      <div>
        <div className="auth-container-box">
          <Box className="auth-single-form">
            <Text className="auth-title">Create New Password</Text>
            <Text className="auth-description">
              Enter your new password below.
            </Text>
            <form
              onSubmit={form.onSubmit((values) => onSubmit(values))}
              className="u-w-100"
            >
              <List size="xs" mt={"lg"} px={"md"} spacing={-2}>
                Password Rules
                <List.Item>Minimum 8 characters</List.Item>
                <List.Item>An uppercase letter</List.Item>
                <List.Item>A lowercase letter</List.Item>
                <List.Item>A number</List.Item>
              </List>

              <Space h="md" />
              <TextInput
                required
                label="New Password"
                placeholder="Enter new password"
                className="u-w-100"
                {...form.getInputProps("new_password")}
                type="password"
              />

              <Group mt="lg" mb="sm">
                <Button
                  size="lg"
                  type="submit"
                  className="u-w-100 auth-submit-button"
                >
                  CHANGE PASSWORD
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="u-w-100 mobile-auth-button"
                  onClick={() => history.push(URL_PATHS.LOGIN)}
                >
                  BACK TO LOGIN
                </Button>
              </Group>

              <Text
                size="sm"
                align="left"
                className="auth-link"
                onClick={() => history.push(URL_PATHS.LOGIN)}
              >
                <FontAwesomeIcon icon={faLongArrowAltLeft as Icon} /> Back to
                login
              </Text>
            </form>
          </Box>
        </div>
      </div>
    );
  } else {
    return <Redirect to={URL_PATHS.APP} />;
  }
};

export default ChangePasswordPage;
